import { call, put } from 'redux-saga/effects';
import { apiGeneral, notify } from 'services';
import { IUpdateRequest } from 'interfaces/update-duck';
import { requestErrorHandler } from 'utils';
import { DeleteAlertActions } from 'store/ducks/settings/alerts';

export function* deleteAlertRequest(action: any) {
  try {
    const { id, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.delete,
      `/alerts/${id}`
    );

    const { data } = responseBody;
    yield put(DeleteAlertActions.success(data));
    notify('success', 'Alerta deletado com sucesso');
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(DeleteAlertActions.failure(errorMessage));
  }
}
